import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import BusinessHoursBlock from "./BusinessHoursBlock";

function Footer() {
  return (
    <section className="flex flex-col">
      <img
        src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/footergrass-2-1.png"
        alt="Dekoracyjna trawa - stopka Drzewus"
      />
      <div className="bg-[#260a05] p-6 lg:px-24 lg:py-12 flex flex-col">
        <div className="w-full flex flex-col lg:flex-row items-start justify-start lg:justify-between">
          <div className="flex flex-col items-start justify-start text-left">
            <img
              className="h-24 pb-2"
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
              alt="Logo Drzewus - usługi ogrodnicze"
            />
            <p className="text-white max-w-[400px] font-bold pb-4">
              Usługi ogrodznicze i prace ziemne
            </p>
            <p className="text-white max-w-[400px] opacity-50">
              <strong>Rozwiążemy komplikacje związane z Twoją działką! </strong>
              Gdy przy pracy napotykamy niestandardowe sytuacje, to zawsze
              szukamy najlepszego dla Ciebie rozwiązania. Doradzimy i
              podpowiemy, bo mamy talent do zakładania ogrodów.
            </p>
            <div className="flex gap-4 mt-4 text-white">

              <a
                href="https://www.facebook.com/drzewuspomorskie"
                className="text-2xl hover:opacity-50 transition duration-300 ease-linear"
              >
                <FaFacebook />
              </a>


               <a
                href="https://www.youtube.com/@drzewusmistrzterenu"
                className="text-2xl hover:opacity-50 transition duration-300 ease-linear"
              >
                <FaYoutube />
              </a>

              
            </div>
            <BusinessHoursBlock
              className="mt-6 max-w-[400px]"
              titleClassName="mb-0 font-head text-white text-sm font-semibold"
              lineClassName="text-white text-sm opacity-50"
            />
          </div>
          <div className="flex flex-col items-start justify-start lg:items-end lg:justify-start gap-6 mt-6 lg:mt-0">
            <div className="flex flex-col lg:flex-row gap-2 lg:gap-6 items-start justify-start text-left lg:text-right">
              <a
                href="tel:+48604351852"
                className="mb-2 font-head text-white hover:opacity-50 transition duration-300 ease-linear text-xl lg:text-3xl font-semibold"
              >
                +48 604 351 852
              </a>
              <a
                href="mailto:kontakt@drzewus.pl"
                className="font-head text-white hover:opacity-50 transition duration-300 ease-linear text-xl lg:text-3xl font-semibold"
              >
                kontakt@drzewus.pl
              </a>
            </div>
            <div className="flex flex-col items-start justify-start lg:flex-row lg:items-start lg:justify-end gap-6 w-full text-left">
              <div className="flex flex-col items-start justify-start">
                <p className="mb-2 font-head text-white">Oczyszczanie terenu</p>
                <a
                  href="/oczyszczanie-terenu/mulczer-lesny"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Mulczer leśny
                </a>
                <a
                  href="/oczyszczanie-terenu/wycinka-klasyczna"
                  className="block text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Wycinka drzew - klasyczna
                </a>
                <a
                  href="/oczyszczanie-terenu/wycinka-alpinistyczna"
                  className="block text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Wycinka drzew - alpinistyczna
                </a>
                <a
                  href="/oczyszczanie-terenu/karczowanie-drzew"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Karczowanie drzew
                </a>
                <a
                  href="/oczyszczanie-terenu/frezowanie-pni"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Frezowanie pni
                </a>
                <a
                  href="/oczyszczanie-terenu/prace-ziemne"
                  className="block text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Prace ziemne
                </a>
                <a
                  href="/oczyszczanie-terenu/niewelacja-terenu"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Niwelacja terenu
                </a>
                <a
                  href="/oczyszczanie-terenu/przygotowanie-dokumentacji"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Przygotowanie dokumentacji
                </a>
                <a
                  href="/oczyszczanie-terenu/ekspertyzy"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Ekspertyzy
                </a>
              </div>
              

              <div className="flex flex-col items-start justify-start">
                <p className="mb-2 font-head text-white">Prace ziemne</p>
                <a
                  href="/prace-ziemne"
                  className="block text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Prace ziemne
                </a>
                <a
                  href="/prace-ziemne/rownanie-terenu"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Równanie terenu
                </a>
                <a
                  href="/prace-ziemne/czyszczenie-dzialek"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Czyszczenie działek
                </a>
                <a
                  href="/prace-ziemne/wycinka-drzew"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Wycinka drzew
                </a>
              </div>

              <div className="flex flex-col items-start justify-start">
                <p className="mb-2 font-head text-white">Zakładanie ogrodu</p>
                <a
                  href="/zakladanie-ogrodu/projektowanie"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Projektowanie
                </a>
                <a
                  href="/zakladanie-ogrodu/"
                  className="block text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Zakładanie ogrodu
                </a>
                <a
                  href="/zakladanie-ogrodu/niwelacja-terenu"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Niwelacja terenu
                </a>
                <a
                  href="/zakladanie-ogrodu/prace-ziemne"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Prace ziemne
                </a>
                <a
                  href="/zakladanie-ogrodu/nawodnienie"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Nawodnienie
                </a>
                <a
                  href="/zakladanie-ogrodu/trawa-z-rolki"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Trawa z rolki
                </a>
                <a
                  href="/zakladanie-ogrodu/trawa-z-siewu"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Trawa z siewu
                </a>
                <a
                  href="/zakladanie-ogrodu/usluga-glebogryzarki"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Usługa glebogryzarki
                </a>
              </div>

              <div className="flex flex-col items-start justify-start">
                <p className="mb-2 font-head text-white">Ogrodzenia</p>
                <a
                  href="/ogrodzenia"
                  className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                >
                  Ogrodzenia
                </a>
              </div>

                <div className="flex flex-col items-start justify-start">
                  <p className="mb-2 font-head text-white">Inne</p>

                  <a
                    href="https://info-firm.net"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Katalog firm"
                    className="mb-2 opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                  >
                    <img src="https://info-firm.net/antipixel.png" alt="Katalog firm" />
                  </a>
                  <a
                    href="https://efipo.pl/zbychowo-pow-wejherowski-woj-pomorskie/drzewus-uslugi-ogrodnicze-i-prace-ziemne"
                    title="Drzewus - Usługi ogrodnicze i prace ziemne w efipo.pl"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
                  >
                    Oceń nas w efipo.pl
                  </a>
                </div>

            </div>
          </div>
        </div>
        <span className="w-full h-[1px] bg-white mt-12 mb-6"></span>
        <div className="w-full flex flex-col items-start justify-start lg:flex-row lg:items-center lg:justify-between">
          <a
            className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer mb-2 lg:mb-0"
            href="https://ifil.pl"
          >
            projekt i implementacja iFil Group, 2024
          </a>
          <a
              href="/llms.txt"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer mb-2 lg:mb-0"
            >
              LLMS.txt
            </a>
          <div className="flex flex-col items-start justify-start lg:flex-row lg:items-center lg:justify-end gap-2">
            <a
              href="/polityka-prywatnosci"
              className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
            >
              Polityka Prywatności
            </a>
            <a
              href="/regulamin-serwisu"
              className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
            >
              Regulamin Serwisu
            </a>
            <a
              href="/obowiazek-informacyjny"
              className="text-white opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
            >
              Obowiązek informacyjny
            </a>
          </div>
        </div>
      </div>
      <div className="bg-white grid grid-cols-2 lg:grid-cols-6 p-6 gap-2 text-left">
        {[
          "Wejherowo",
          "Kartuzy",
          "Chmielno",
          "Przodkowo",
          "Sierakowice",
          "Somonino",
          "Stężyca",
          "Sulęczyno",
          "Gdańsk",
          "Kosakowo",
          "Krokowa",
          "Puck",
          "Lębork",
          "Słupsk",
          "Tczew",
          "Pruszcz Gdański",
          "Przywidz",
          "Żukowo",
          "Łeba",
          "Władysławowo",
          "Skarszewy",
          "Sztum",
          "Bolszewo",
          "Orle",
          "Luzino",
        ].map((city, index) => (
          <a
            key={index}
            href={`/${city.toLowerCase().replaceAll(" ", "-")}`}
            className="color-green opacity-50 hover:opacity-100 transition duration-300 ease-linear cursor-pointer"
          >
            {city}
          </a>
        ))}
      </div>
    </section>
  );
}

export default Footer;
